import { useReduxState } from 'hooks';
import { FlexContainer, Search } from 'components/common';
import { Filters, FiltersActive } from 'components/common/filter';

interface Props {
  filterId: string;
  filters: Record<string, boolean>;
}

/**
 * Search and filters for the answers list, matching
 * `CalendarEventFeedbackResponsesSubHeader` - everything here ends up in the
 * url, so paging through the list and coming back keeps the same view.
 */
const CalendarEventFeedbackQuestionAnswersSubHeader = ({
  filterId,
  filters
}: Props) => {
  const { messages } = useReduxState();

  return (
    <>
      <FlexContainer style={{ flexWrap: 'wrap', gap: 10, width: '100%' }}>
        <div style={{ minWidth: 240 }}>
          <Search
            placeholder={messages.usersSearchUsers}
            size="header"
            withUrl={true}
          />
        </div>

        <Filters
          allowMultiple={filters}
          filterId={filterId}
          filters={filters}
        />
      </FlexContainer>

      <FiltersActive filterId={filterId} />
    </>
  );
};

export default CalendarEventFeedbackQuestionAnswersSubHeader;
